import React from "react";
import AppContext from "../../AppContext";

import { withTranslation } from "react-i18next";

import { isMobileSafari } from "react-device-detect";
import MediaQuery from "react-responsive";

import ControlPanel from "../controlPanel/controlPanel";
import MarkerIn from "../markers/markerIn";
import MarkerOut from "../markers/markerOut";
import MarkerBed from "../markers/markerBed";
import MarkerGarden from "../markers/markerGarden";
import ToggleAudio from "../toggleAudio/toggleAudio";
import BackgroundAudio from "../backgroundAudio/backgroundAudio";
import Disclaimer from "../disclaimer/disclaimer";
import ImprintExt from "../imprint-ext/imprint-ext";
import AGB from "../agb/agb";
import PrivacyPolicy from "../privacyPolicy/privacyPolicy";

import styles from "../../styles/products.module.css";

class Products extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active: 5,
      visible: true,
      bgVisible: false,
      audioContextHeatpump: new (window.AudioContext ||
        window.webkitAudioContext)(),
      mediaSourceHeatpump: {},
      gainNodeHeatpump: {},
    };
  }

  static contextType = AppContext;

  componentDidMount() {
    setTimeout(() => {
      this.setState({ bgVisible: true });
    }, 500);

    if (isMobileSafari) {
      this.setupHeatpumpAudio();
    }
  }

  isInFrame = () => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("forceFrameMode")) {
      return true;
    }
    return window.self !== window.top;
  };

  changeInputVisiable = () => {
    if (this.state.visible) {
      this.setState({ visible: false });
    } else {
      this.setState({ visible: true });
    }
  };

  changeZoomLevel = (zoom) => {
    this.setState({ active: zoom });
  };

  async setupHeatpumpAudio() {
    await this.setState({
      audioContextHeatpump: new (window.AudioContext ||
        window.webkitAudioContext)(),
    });

    var heatpump = document.getElementById("heatpumpAudioContainer");
    console.log(this.state.audioContextHeatpump);

    await this.setState({
      mediaSourceHeatpump:
        this.state.audioContextHeatpump.createMediaElementSource(heatpump),
    });
    console.log(this.state.mediaSourceHeatpump);

    await this.setState({
      gainNodeHeatpump: this.state.audioContextHeatpump.createGain(),
    });
    console.log(this.state.gainNodeHeatpump);
  }

  render() {
    const { products, activeView, time, productSelected, menuOpen } =
      this.context;
    const bgVisible = this.state.bgVisible;

    return (
      <div className={`${styles.productContainer}`}>
        <div>
          <BackgroundAudio />
        </div>

        <MediaQuery minWidth={601}>
          <div
            className={`${!menuOpen ? styles.fadeIn : styles.hide} ${
              styles.scaleMarker
            }`}
            style={{
              position: "absolute",
              marginLeft: "0",
              width: "auto",
              padding: "10px",
              zIndex: "999999999",
              left:
                activeView !== 2
                  ? products[productSelected].floatingToggle[0]
                  : products[productSelected].floatingToggle[2],
              bottom:
                activeView !== 2
                  ? products[productSelected].floatingToggle[1]
                  : products[productSelected].floatingToggle[3],
            }}
          >
            <ToggleAudio />
          </div>

          <div
            className={`${!menuOpen ? styles.show : styles.hide} ${
              styles.marker
            }`}
          >
            <div
              className={`${activeView === 0 ? styles.fadeIn : styles.hide} ${
                styles.scaleMarker
              }`}
              style={{
                position: "absolute",
                left: products[productSelected].marker1m[0],
                bottom: products[productSelected].marker1m[1],
                width: "auto",
                zIndex: "999999999",
              }}
            >
              <MarkerIn
                action={this.changeZoomLevel}
                audioCtx={this.state.audioContextHeatpump}
                mediaSrc={this.state.mediaSourceHeatpump}
                gainNode={this.state.gainNodeHeatpump}
              />
            </div>
            <div
              className={`${activeView === 1 ? styles.fadeIn : styles.hide} ${
                styles.scaleMarker
              }`}
              style={{
                position: "absolute",
                left: products[productSelected].marker3m[0],
                bottom: products[productSelected].marker3m[1],
                width: "auto",
                zIndex: "999999999",
              }}
            >
              <MarkerOut
                action={this.changeZoomLevel}
                audioCtx={this.state.audioContextHeatpump}
                mediaSrc={this.state.mediaSourceHeatpump}
                gainNode={this.state.gainNodeHeatpump}
              />
            </div>
            <div
              className={`${activeView !== 2 ? styles.fadeIn : styles.hide} ${
                styles.scaleMarker
              }`}
              style={{
                position: "absolute",
                zIndex: "999999999",
                width: "auto",
                left:
                  activeView === 0
                    ? products[productSelected].markerBed[0]
                    : products[productSelected].markerBed[2],
                bottom:
                  activeView === 0
                    ? products[productSelected].markerBed[1]
                    : products[productSelected].markerBed[3],
              }}
            >
              <MarkerBed
                action={this.changeZoomLevel}
                audioCtx={this.state.audioContextHeatpump}
                mediaSrc={this.state.mediaSourceHeatpump}
                gainNode={this.state.gainNodeHeatpump}
              />
            </div>
            <div
              className={`${activeView === 2 ? styles.fadeIn : styles.hide} ${
                styles.scaleMarker
              }`}
              style={{
                position: "absolute",
                left: products[productSelected].markerGarden[0],
                bottom: products[productSelected].markerGarden[1],
                width: "auto",
                zIndex: "999999999",
              }}
            >
              <MarkerGarden
                action={this.changeZoomLevel}
                audioCtx={this.state.audioContextHeatpump}
                mediaSrc={this.state.mediaSourceHeatpump}
                gainNode={this.state.gainNodeHeatpump}
              />
            </div>
          </div>
        </MediaQuery>

        <div className={`${bgVisible ? styles.parentTest : ""}`}>
          <div
            className={
              activeView === 0 && !time ? styles.highZIndex : styles.lowZIndex
            }
          >
            <div>
              <img
                src={require(`../../assets/img/${products[productSelected].images[1]}.webp`)}
                alt=""
                className={`${styles.hidden} ${styles.houseBackground} ${
                  bgVisible ? styles.visible : styles.hidden
                } ${
                  activeView === 0 && !time ? styles.fadeIn : styles.fadeOut
                }`}
              />
            </div>
          </div>
          <div
            className={
              activeView === 0 && time ? styles.highZIndex : styles.lowZIndex
            }
          >
            <div>
              <img
                src={require(`../../assets/img/${products[productSelected].images[1]}-night.webp`)}
                alt=""
                styles={{ width: "100%" }}
                className={`${styles.hidden} ${
                  bgVisible ? styles.visible : styles.hidden
                } ${activeView === 0 && time ? styles.fadeIn : styles.fadeOut}`}
              />
            </div>
          </div>
          <div
            className={
              activeView === 1 && !time ? styles.highZIndex : styles.lowZIndex
            }
          >
            <div>
              <img
                src={require(`../../assets/img/${products[productSelected].images[2]}.webp`)}
                alt=""
                styles={{ width: "100%" }}
                className={`${styles.hidden} ${
                  bgVisible ? styles.visible : styles.hidden
                } ${
                  activeView === 1 && !time ? styles.fadeIn : styles.fadeOut
                }`}
              />
            </div>
          </div>
          <div
            className={
              activeView === 1 && time ? styles.highZIndex : styles.lowZIndex
            }
          >
            <div>
              <img
                src={require(`../../assets/img/${products[productSelected].images[2]}-night.webp`)}
                alt=""
                styles={{ width: "100%" }}
                className={`${styles.hidden} ${
                  bgVisible ? styles.visible : styles.hidden
                } ${activeView === 1 && time ? styles.fadeIn : styles.fadeOut}`}
              />
            </div>
          </div>
          <div
            className={
              activeView === 2 && !time ? styles.highZIndex : styles.lowZIndex
            }
          >
            <div>
              <img
                src={require(`../../assets/img/${products[productSelected].images[3]}.webp`)}
                alt=""
                styles={{ width: "100%" }}
                className={`${styles.hidden} ${
                  bgVisible ? styles.visible : styles.hidden
                } ${
                  activeView === 2 && !time ? styles.fadeIn : styles.fadeOut
                }`}
              />
            </div>
          </div>
          <div
            className={
              activeView === 2 && time ? styles.highZIndex : styles.lowZIndex
            }
          >
            <div>
              <img
                src={require(`../../assets/img/${products[productSelected].images[4]}.webp`)}
                alt=""
                styles={{ width: "100%" }}
                className={`${styles.hidden} ${
                  bgVisible ? styles.visible : styles.hidden
                } ${activeView === 2 && time ? styles.fadeIn : styles.fadeOut}`}
              />
            </div>
          </div>
        </div>

        <MediaQuery maxWidth={599}>
          <div className={styles.mobileMenu}>
            <ControlPanel
              action={this.changeZoomLevel}
              lang={this.props.match.params.lang}
              audio={products[productSelected].audio[0]}
              audioCtx={this.state.audioContextHeatpump}
              mediaSrc={this.state.mediaSourceHeatpump}
              gainNode={this.state.gainNodeHeatpump}
            />
          </div>
        </MediaQuery>
        <MediaQuery minWidth={600}>
          <div className={styles.isDesktop}>
            <ControlPanel
              action={this.changeZoomLevel}
              lang={this.props.match.params.lang}
              audio={products[productSelected].audio[0]}
              audioCtx={this.state.audioContextHeatpump}
              mediaSrc={this.state.mediaSourceHeatpump}
              gainNode={this.state.gainNodeHeatpump}
            />
          </div>
        </MediaQuery>

        <div className={styles.legalContainer}>
          <Disclaimer />
          {!this.isInFrame() && (
            <>
              <ImprintExt />
              <AGB />
              <PrivacyPolicy />
            </>
          )}
        </div>

        <audio
          id="heatpumpAudioContainer"
          className={styles.hide}
          controls
          loop
          src={require(`../../assets/audio/${products[productSelected].audio[0]}`)}
        >
          Your browser does not support the
          <code>audio</code> element.
        </audio>
      </div>
    );
  }
}

export default withTranslation()(Products);

